/**
 * 리치 에디터의 **유일한 문**. 화면은 이것만 쓴다.
 *
 * ⭐ tiptap 은 **글을 쓰는 사람만** 받는다 — 읽는 사람은 0 KB 다(조건 ③ 「무겁지 않음」).
 *   그래서 `RichTextEditor` 를 동적 `import()` 로만 부른다. 정적으로 부르면 그 순간
 *   tiptap 이 화면 진입 번들에 들어가 **읽는 사람에게도 실려 나간다.**
 *
 * ⛔ 이 파일 말고 어디서도 `./RichTextEditor` 를 import 하지 말 것.
 *   `lazy-load-boundary.test.ts` 가 소스를 훑어 그것을 잠근다.
 */

import { Suspense, lazy } from 'react';
import type { RichTextEditorProps } from './RichTextEditor';

const RichTextEditor = lazy(() => import('./RichTextEditor'));

/** 에디터를 내려받는 동안 자리를 지킨다 — 높이가 튀지 않게 같은 최소 높이를 쓴다. */
export function RichTextEditorFallback() {
  return <div className="axi-rte axi-rte--loading" aria-busy="true">{'편집기를 불러오는 중입니다'}</div>;
}

export function LazyRichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense fallback={<RichTextEditorFallback />}>
      <RichTextEditor {...props} />
    </Suspense>
  );
}

export type { RichTextEditorProps };
